import React from 'react'
import Text from '../Text'
import styles from './styles.module.css'
import Loading from './Loading'

// Reproduce the former styled `${props => ...}` color/border matrix as a class
// combination: base + one of dark/primary/darkPrimary (+ fullHeight).
const variantClass = (base, { primary, dark, fullHeight }) => {
  const classes = [base]
  if (dark && primary) classes.push(styles.darkPrimary)
  else if (dark) classes.push(styles.dark)
  else if (primary) classes.push(styles.primary)
  if (fullHeight) classes.push(styles.fullHeight)
  return classes.join(' ')
}

function CtaLoading(props) {
  const { title, onClick, primary, dark, type, disabled, isLoading, fullHeight } = props

  if (onClick || type) {
    return (
      <button
        className={variantClass(styles.buttonBase, { primary, dark, fullHeight })}
        onClick={onClick}
        type={type}
        disabled={disabled}
      >
        {isLoading && <Loading dark={primary} />}
        {!isLoading && <Text type="button-1">{title}</Text>}
      </button>
    )
  } else {
    return (
      <a className={variantClass(styles.linkBase, { primary, dark, fullHeight })}>
        {isLoading && <Loading />}
        {!isLoading && <Text type="button-1">{title}</Text>}
      </a>
    )
  }
}

export default CtaLoading
